import { render, staticRenderFns } from "./CalculadoraMatriculacion.vue?vue&type=template&id=a96e8906&scoped=true&"
import script from "./CalculadoraMatriculacion.vue?vue&type=script&lang=js&"
export * from "./CalculadoraMatriculacion.vue?vue&type=script&lang=js&"
import style0 from "./CalculadoraMatriculacion.vue?vue&type=style&index=0&id=a96e8906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96e8906",
  null
  
)

export default component.exports